import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/Top.vue'
import MapShare from '../views/MapShare.vue'
import NotFound from '../views/NotFound.vue'
import Title from '../views/Title.vue'
import TermsOfUse from '../views/TermsOfUse.vue'
import ExternalTransmissionPolicy from '../views/ExternalTransmissionPolicy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/top',
    name: 'Top',
    component: Top
  },
  {
    path: '/',
    name: 'Title',
    component: Title
  },
  {
    path: '/mapshare',
    name: 'MapShare',
    component: MapShare
  },
  {
    path: '/TermsOfUse',
    name: 'TermsOfUse',
    component: TermsOfUse
  },
  {
    path: '/ExternalTransmissionPolicy',
    name: 'ExternalTransmissionPolicy',
    component: ExternalTransmissionPolicy
  },
  // {
  //   path: '/mapselect',
  //   name: 'MapSelect',
  //   component: MapSelect
  // },
  // {
  //   path: '/mapset',
  //   name: 'MapSet',
  //   component: MapSet
  // },
  // {
  //   path: '/mapdesign',
  //   name: 'MapDesign',
  //   component: MapDesign
  // },
  // {
  //   path: '/az',
  //   name: 'AZ',
  //   component: AZ
  // },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/design_map_ai/',
  routes
})

export default router
